// extracted by mini-css-extract-plugin
export default {"card":"TrendChart_card__dQPj1","title":"TrendChart_title__OT4F4"};